import type { FaireProductEntity } from "../../entity_types/product";

export const p_j7nfmmc4ce: FaireProductEntity = {
  token: "p_j7nfmmc4ce",
  type: "product",
  name: "Western 18K Gold Non-Tarnish Horseshoe Charm Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/637cfcd8be447273bb491693f2c287052342756455566994eec3b71abde19126.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43e662fc2946c7644f1f2739d4dee21a63958dee6c99722b81abb733189ddabc.jpeg",
    "https://cdn.faire.com/fastly/6c01f7ade614e2ece1b7ad9e5bc0fd9761f1bea51ecb71949c4c6b7e973d1e0e.jpeg",
    "https://cdn.faire.com/fastly/041c0d0a394f17b230c3cb305d33c755f1311185320a008e20e777eee48476ef.jpeg",
  ],
  priceDollars: 13.59,
  description:
    "18K Gold Non-Tarnish Horseshoe Charm Necklace\n18K Gold Plated\nStainless Steel\nPendant Size (inch): 0.79\nChain Length (inch): 17.7\nExtension Length (inch): 2\n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:40.656Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
